/**
 * useTierAdjustments Hook (Web)
 * Thin wrapper around shared useTierAdjustments
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseTierAdjustmentsResult,
  useTierAdjustments as useTierAdjustmentsShared,
} from '@parlay-picker/shared/hooks/useTierAdjustments';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export function useTierAdjustments(enabled = true): UseTierAdjustmentsResult {
  const { authFetch } = useAuth();
  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );
  return useTierAdjustmentsShared({ httpClient, enabled });
}
